import React from 'react';
import SVG from 'react-inlinesvg';
import { routes, copyFor } from 'config';
import { Container, Page } from 'styles';
import { Link, Text, SocialMediaLink, CopyButton } from '@perch-labs/shrike';
import { SHARE_URL } from 'domain/advocacy';
import SuccessIcon from '/images/advocacy/success.svg';
import SolarPanels from '/images/advocacy/more-solar-panels.png';
import { useAdvocacyContext } from 'contexts/advocacy';
import { ShareWrapper, TextWrapper, StyledImg } from './success.style';

const getCopy = copyFor('advocacy.success');
const getSocialCopy = copyFor('social');

const successImageWidth = `539px`;

export const Success = () => {
  const { campaign, stateAbbreviation } = useAdvocacyContext();
  const { successMessage, successTitle, shareText } = campaign;

  const sharePrompt = campaign.isDefault
    ? getCopy('sharePrompt.default', { stateAbbreviation })
    : getCopy('sharePrompt.nonDefault');

  const image = campaign.isDefault ? (
    <StyledImg src={SolarPanels} aria-label={getCopy('imageAriaLabel')} />
  ) : (
    <SVG
      height="189px"
      width={successImageWidth}
      max-width="100vw"
      src={SuccessIcon}
      aria-hidden="true"
    />
  );

  return (
    <Page maxWidth={successImageWidth}>
      <Container
        flex
        direction="column"
        alignItems="center"
        padding={{ top: '48px' }}
        small={{ padding: { top: '0px' } }}
      >
        {image}
        <TextWrapper>
          <Text tag="h1" margin={{ top: '34px' }} textStyle="heading800">
            {successTitle}
          </Text>
          <Text margin={{ bottom: '16px', top: '16px' }}>{successMessage}</Text>
          <Link to={routes().dashboard}>{getCopy('backToDashboard')}</Link>
          <Text
            tag="h2"
            margin={{ bottom: '16px', top: '64px' }}
            textStyle="heading700"
          >
            {sharePrompt}
          </Text>
          <ShareWrapper>
            <Text margin={{ bottom: '24px' }}>{shareText}</Text>
            <Container flex direction="row" justifyContent="center">
              <CopyButton
                aria-label={getCopy('copyAriaLabel')}
                copyText={shareText}
                margin={{ right: '8px' }}
                backgroundless
              />
              <SocialMediaLink
                platform="facebook"
                aria-label={getSocialCopy('share', { platform: 'Facebook' })}
                url={SHARE_URL}
                margin={{ right: '8px' }}
              >
                {getCopy('share')}
              </SocialMediaLink>
              <SocialMediaLink
                platform="twitter"
                aria-label={getSocialCopy('share', { platform: 'Twitter' })}
                text={shareText}
                url={SHARE_URL}
                hashtags="solar,arcadia"
              >
                {getCopy('tweet')}
              </SocialMediaLink>
            </Container>
          </ShareWrapper>
        </TextWrapper>
      </Container>
    </Page>
  );
};
